// extracted by mini-css-extract-plugin
export default {"filtersToggleContainer":"search_query_section_decisions-module__filtersToggleContainer--2cWHN"};